import { useEffect } from 'react';

const BASE_TITLE = 'SBR2TH Recruiting Inc.';

export const usePageTitle = (pageTitle: string) => {
    useEffect(() => {
        if (!pageTitle) return;
        document.title = `${pageTitle} | ${BASE_TITLE}`;
    }, [pageTitle]);
};


